import { createSlice } from "@reduxjs/toolkit";
import { getPalms } from "../actions/palm.actions";

const initialState = {
  palms: {} as any,
  loading: false,
  error: null as unknown | null,
};
export const palmSlice = createSlice({
  name: "palm",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPalms.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPalms.fulfilled, (state, action) => {
        state.palms = action.payload;
        state.loading = false;
      })
      .addCase(getPalms.rejected, (state, action) => {
        state.palms = {};
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default palmSlice.reducer;
